import React, { Fragment, HTMLProps } from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumbs.module.scss';
import { BreadcrumbType } from '../../../admin/hooks/useAdminProjectBreadcrumbs';

interface BreadcrumbsProps extends HTMLProps<HTMLDivElement> {
    steps: BreadcrumbType[];
}

const divider = ' > ';

export default function Breadcrumbs({ steps }: BreadcrumbsProps) {
    return <div className={styles.breadcrumbs}>{steps.map(renderStep)}</div>;

    function renderStep(step: BreadcrumbType, index: number) {
        const { label, link } = step;
        const count = steps.length;

        if (link && index !== count - 1) {
            return (
                <Fragment key={index}>
                    <Link to={link} relative="path">
                        {label}
                    </Link>
                    {divider}
                </Fragment>
            );
        }

        return <div className={styles.last}>{label}</div>;
    }
}
